varying vec3 vPos;
uniform float uTime;
uniform float uScroll;

void main()
{
  float distanceToCenter = distance(gl_PointCoord, vec2(0.5));
  // Smooth, refined particle falloff instead of harsh bloom
  float strength = 1.0 - smoothstep(0.0, 0.5, distanceToCenter);
  strength = pow(strength, 2.0);

  // Tasteful, high-end color palette (Icy Teal -> Electric Indigo -> Soft White Gold -> Champagne Emerald)
  vec3 colorA = vec3(0.35, 0.85, 0.95); // Crisp Icy Cyan
  vec3 colorB = vec3(0.55, 0.45, 0.98); // Soft Violet
  vec3 colorC = vec3(0.95, 0.90, 0.85); // Warm Platinum
  vec3 colorD = vec3(0.20, 0.90, 0.70); // Emerald Teal

  vec3 color = colorA;

  if (uScroll < uRange) {
    color = mix(colorA, colorB, uScroll * uTotalModels);
  } else if (uScroll < uRange * 2.0) {
    color = mix(colorB, colorC, (uScroll - uRange) * uTotalModels);
  } else if (uScroll < uRange * 3.0) {
    color = mix(colorC, colorD, (uScroll - uRange * 2.0) * uTotalModels);
  } else {
    color = mix(colorD, colorA, (uScroll - uRange * 3.0) * uTotalModels);
  }

  gl_FragColor = vec4(color, strength * 0.85);
}
